import { render, staticRenderFns } from "./International2.vue?vue&type=template&id=3a7f5f22&scoped=true"
import script from "./International2.vue?vue&type=script&lang=js"
export * from "./International2.vue?vue&type=script&lang=js"
import style0 from "./International2.vue?vue&type=style&index=0&id=3a7f5f22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7f5f22",
  null
  
)

export default component.exports